import React from 'react';
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import ToggleButton from "react-toggle-button";
import { themeCSSConstants } from 'redux/constant/themeCSS';
import { IoMdAdd } from 'react-icons/io'

class OrderAttributeForm extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        this.state = {
            brand_order_attributes: {
                ...this.props.brandPro,
            },
            submitted: false,
            formType: this.props.formTypePro || '',
            duplicate_error: false,
        };
        this.handleList = this.handleList.bind(this);
        this.handleListSubmitForm = this.handleListSubmitForm.bind(this);
    }
    handleList(e) {
        const { name, value } = e.target;
        this.setState(prevState => ({
            brand_order_attributes: {
                ...prevState.brand_order_attributes,
                [name]: value
            }
        }));
    }

    handleChangeState = (selectedOption, name) => {
        if (name.action === 'select-option') {
            this.setState({
                brand_order_attributes: {
                    ...this.state.brand_order_attributes,
                    [name.name]: selectedOption.value,
                }
            })
        }
    }

    onCheckFlag = (toggle, name) => {
        this.setState({
            brand_order_attributes: {
                ...this.state.brand_order_attributes,
                [name]: !toggle
            }
        });
    }
    onInputHandler = (e) => {
        this.setState({
            brand_order_attributes: {
                ...this.state.brand_order_attributes,
                [e.target.name]: e.target.value
            }
        });
    }
    handleCheckStatus = (e) => {
        const { name, checked } = e.target;
        this.setState({
            brand_order_attributes: {
                ...this.state.brand_order_attributes,
                [name]: checked,
            }
        })
    }
    handleListSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            const filtered = this.props.attributesProp.filter(data => {
                return data.title.toLowerCase() === this.state.brand_order_attributes.title.toLowerCase()
            })

            if (filtered.length > 0) {
                this.setState({
                    duplicate_error: true
                })
                return;
            }
            const attributes = {...this.state.brand_order_attributes};
            const title = this.state.brand_order_attributes['title'];
            const db_column = this.state.brand_order_attributes['title'].replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g, '').replace(/\s+/g, '_').toLowerCase();
            attributes['title'] = title;
            attributes['db_column'] = db_column;
            if (this.props.adjustable_array.length == 0) {
                attributes.adjust_product_attribute = ''
            }
            this.props.handleSubmit(attributes, this.state.formType);
            this.setState({
                brand_order_attributes: {
                    ...this.props.brandPro,
                },
                submitted: true,
                formType: this.props.formTypePro || '',
                duplicate_error: false,
            })
            this.valitdatorList.hideMessages();
        } else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.brand_order_attributes !== prevState.brand_order_attributes && this.state.duplicate_error) {
            if (this.state.brand_order_attributes.title !== prevState.brand_order_attributes.title) {
                this.setState({
                    duplicate_error: false
                })
            }
        }

        if (this.props.adjustable_array.length > 0 && this.props.adjustable_array !== prevProps.adjustable_array) {
            this.setState({
                brand_order_attributes: {
                    ...this.state.brand_order_attributes,
                    adjust_product_attribute: this.props.adjustable_array[0].value
                }
            })
        }

        if (this.state.submitted && this.props.adjustable_array.length > 0) {
            this.setState({
                submitted: false,
                brand_order_attributes: {
                    ...this.state.brand_order_attributes,
                    adjust_product_attribute: this.props.adjustable_array[0].value
                }
            })
        }
    }

    render() {
        const { brand_order_attributes } = this.state;
        this.valitdatorList.purgeFields();
        return (
            <tr style={{ backgroundColor: "#d2dfeb" }}>
                <td>
                    {this.props.attributesLength}
                </td>
                <td>
                    <input type="text" name="title" className="form-control" value={brand_order_attributes.title} onChange={this.handleList} />
                    {this.state.duplicate_error && <span style={{ color: 'red' }}>Title already exists in the list.</span>}
                    {this.valitdatorList.message('Title', brand_order_attributes.title, 'required')}
                </td>

                <td>
                    <input type="text" name="cart_label" className="form-control" value={brand_order_attributes.cart_label} onChange={this.handleList} />
                    {this.valitdatorList.message('Cart Label', brand_order_attributes.cart_label, 'required')}
                </td>

                <td>
                    <input type="text" name="sample_value" className="form-control" value={brand_order_attributes.sample_value} onChange={this.handleList} />
                    {this.valitdatorList.message('Sample Value', brand_order_attributes.sample_value, 'required')}
                </td>

                <td width='215'>
                    <Select
                        value={HF.returnLabelWithValue(this.state.brand_order_attributes.data_type, OC.dataTypeList)}
                        onChange={this.handleChangeState}
                        options={OC.dataTypeList}
                        isSearchable={true}
                        name={'data_type'}
                        isMulti={false}
                        placeholder={'Select Datatype'}
                        isClearable={false}
                    />
                    {this.valitdatorList.message('Data Type', brand_order_attributes.data_type, 'required')}

                </td>

                <td className="switch_center">
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={this.state.brand_order_attributes['show_on_cart']}
                        name="show_on_cart"
                        onToggle={(e) => this.onCheckFlag(e, 'show_on_cart')}
                    />
                </td>

                <td className="switch_center">
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={this.state.brand_order_attributes['is_quantity_attribute']}
                        name="is_quantity_attribute"
                        onToggle={(e) => this.onCheckFlag(e, 'is_quantity_attribute')}
                    />
                </td>

                <td>
                    {
                        this.props.adjustable_array.length > 0 && this.state.brand_order_attributes.is_quantity_attribute ?
                            <React.Fragment>

                                <select className="form-control text-capitalize" onChange={(e) => this.onInputHandler(e)} name='adjust_product_attribute' value={this.state.brand_order_attributes.adjust_product_attribute ? this.state.brand_order_attributes.adjust_product_attribute : ""}>
                                    <option value="" disabled hidden className="text-capitalize">Choose Attribute</option>
                                    {
                                        this.props.adjustable_array.map((data, index) => (
                                            <option value={data.value} key={index} > {data.label} </option>
                                        ))
                                    }
                                </select>
                                {
                                    this.valitdatorList.message('Adjust Prod Attribute', brand_order_attributes.adjust_product_attribute, 'required')
                                }
                            </React.Fragment>
                            :
                            null
                    }
                </td>
                <td>
                    <button className="customBtn btnBlue btnRounded" onClick={this.handleListSubmitForm}><IoMdAdd /></button>
                </td>
            </tr>
        );
    }
}


export default OrderAttributeForm;


// WEBPACK FOOTER //
// ./src/components/Admin/Brands/OrderAttributeForm.jsx